import { Td as ChakraTd } from '@chakra-ui/react'
import styled from 'styled-components'
import { keyframes } from 'styled-components'

const loading = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`

export const TdSkeleton = styled(ChakraTd)`
  animation: ${loading} 1s infinite;
`

export const Skeleton = ({ children }) => <TdSkeleton>{children}</TdSkeleton>
